/**
 * Parses environment variable string array into JSON array
 * @param {string} envString - Environment variable string like "[ 'value1', 'value2' ]"
 * @returns {array} Parsed array
 */
export const parseEnvArray = (envString) => {
  if (!envString) return [];
  const validJsonString = envString.replace(/'/g, '"');
  try {
    return JSON.parse(validJsonString);
  } catch (error) {
    console.error("Failed to parse environment variable:", error);
    return [];
  }
};

/**
 * Generates patient constraints from environment variables
 * @returns {array} Array of constraint objects
 */
export const generateConstraints = () => {
  const constraint1 = parseEnvArray(process.env.REACT_APP_FORM_CONSTRAINT_1);
  const constraint2 = parseEnvArray(process.env.REACT_APP_FORM_CONSTRAINT_2);
  const constraint3 = parseEnvArray(process.env.REACT_APP_FORM_CONSTRAINT_3);

  return [
    {
      type: constraint1[0],
      name: constraint1[1],
      active: constraint1[2],
      severity: constraint1[3],
    },
    {
      type: constraint2[0],
      name: constraint2[1],
      active: constraint2[2],
      severity: constraint2[3],
    },
    {
      type: constraint3[0],
      name: constraint3[1],
      active: constraint3[2],
      severity: constraint3[3],
    },
  ];
};

/**
 * Generates appointment data for a case
 * @param {object} options - Appointment options
 * @param {string} options.aptType - Appointment type (SURGERY, MENTAL_HEALTH, DENTAL, etc.)
 * @param {string} options.planName - Name of the plan
 * @param {string} options.providerId - Provider ID
 * @returns {array} Array of appointment objects
 */
export const generateAppointments = ({ aptType, planName, providerId }) => {
  const apptDate = new Date();

  // Set hours based on aptType
  if (aptType === 'SURGERY') {
    apptDate.setHours(apptDate.getHours() + 4);
  } else if (aptType === 'MENTAL_HEALTH') {
    apptDate.setHours(apptDate.getHours() + 0);
  } else {
    apptDate.setHours(apptDate.getHours() + 24);
  }
  apptDate.setMinutes(apptDate.getMinutes() + 15);

  const isOutreach = planName.toLowerCase().includes("outreach");
  const includeProviderId = aptType !== 'SURGERY' && aptType !== 'MENTAL_HEALTH' && aptType !== 'DENTAL' && aptType !== 'PCP_FOLLOW_UP';

  return [
    {
      title: aptType === "MENTAL_HEALTH" ? "counseling" : planName,
      type: aptType,
      date: isOutreach ? null : apptDate.toISOString(),
      ...(includeProviderId && { providerId }),
      providerData: {
        title: aptType === "MENTAL_HEALTH" ? '' : 'Dr.',
        providerName: 'Jason Bond'
      },
      surgeryType: aptType === 'SURGERY' ? 'Outpatient' : '',
    },
  ];
};
